import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
import { presubmissionListTable } from "../../../shared/tableObjects/admin/presubmissionListTable";

export default function PresubmissionList() {
  const apiClient = useApiClient("AdminApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Presubmission Applications",
      icon: "list-icon icon-spec",
    },
  ];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table apiClient={apiClient} label={""} columns={presubmissionListTable("presubmission")} route={"presubmissionList"} />
      </div>
    </>
  );
}
